import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BackgroundFormService } from 'src/app/services/background-form.service';

@Component({
  selector: 'app-admin-background-form-adult',
  templateUrl: './admin-background-form-adult.component.html',
  styleUrls: ['./admin-background-form-adult.component.scss']
})
export class AdminBackgroundFormAdultComponent implements OnInit {
  appointment: any
  showbutton:boolean=true
  apptId:any
  offset:number;
  dob:any;

  constructor(private bgFormService:BackgroundFormService,private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.apptId=params['appointmentId']
    });
    this.offset = (new Date().getTimezoneOffset());
    this.bgFormService.viewBackgroundFormDetails(this.apptId).subscribe((res)=>{
      this.appointment=res.data
     this.dob= this.appointment.backgroundDetails.dateOfBirth.split('T')[0];
     
    })
   

  }


  



  printPage(){
    this
    window.print()
  }

}
